import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import { useHotspots } from '../../gate/hotspots-provider.js'

const hotspotWidth = 28

const Tooltip = ({ x, y, open, children, content = '' }) => {
  const [active, setActive] = useState(false)
  const [direction, setDirection] = useState('bottom')
  const [tooltipLeft, setTooltipLeft] = useState(null)
  const [tooltipWidth, setTooltipWidth] = useState(0)

  const tooltipRef = useRef(null)

  const { containerSize } = useHotspots()

  const [containerWidth, containerHeight] = containerSize
  const offsetLeft = containerWidth * x
  const offsetTop = containerHeight * y

  const tooltipPositionLeft = useCallback(() => {
    if (offsetLeft < tooltipWidth / 2) {
      setTooltipLeft(tooltipWidth / 2 - (offsetLeft - hotspotWidth / 2))
    } else if (offsetLeft > containerWidth - tooltipWidth / 2) {
      const rightMargin = containerWidth - offsetLeft
      setTooltipLeft(rightMargin - tooltipWidth / 2 + hotspotWidth / 2)
    } else {
      setTooltipLeft(null)
    }
  }, [containerWidth, offsetLeft, tooltipWidth])

  const tooltipPositionTop = useCallback(() => {
    if (offsetTop >= containerHeight - hotspotWidth * 2) {
      setDirection('top')
    } else {
      setDirection('bottom')
    }
  }, [containerHeight, offsetTop])

  useLayoutEffect(() => {
    if (!tooltipRef.current) {
      return
    }
    setTooltipWidth(tooltipRef.current?.clientWidth)
  }, [active, content])

  useLayoutEffect(() => {
    tooltipPositionLeft()
    tooltipPositionTop()
  }, [tooltipPositionLeft, tooltipPositionTop])

  useEffect(() => {
    setActive(open)
  }, [open])

  return (
    <div
      className="flbx-hotspot-tooltip-wrapper"
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
    >
      {children}
      {active && (
        <div
          ref={tooltipRef}
          className={`flbx-hotspot-tooltip ${direction}`}
          style={{
            left: tooltipLeft != null ? `${tooltipLeft}px` : null,
          }}
        >
          {content}
        </div>
      )}
    </div>
  )
}

Tooltip.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  content: PropTypes.string,
  open: PropTypes.bool.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
}

export default Tooltip
